<template>
    <BaseWrapper :loading="loadingSubmit">
        <form action="" class="space-y-4 max-w-2xl mx-auto" @submit.prevent="onSubmit">
            <BaseCard>
                <div class="grid sm:grid-cols-2 gap-4">
                    <SearchOfficeInput type="downline" office-type="member" with-temp-code inset
                        label="Kode Tetap Distributor" placeholder="N-1" required v-model="form.office" />
                    <BaseInput inset type="text" label="Kode Tetap Distributor" placeholder="AB.001-0001" disabled
                        :value="form.office.tempCode" />
                    <BaseInput class="col-span-full" inset type="text" label="Nama Distributor"
                        placeholder="AGUNG SETYAWAN" disabled :value="form.office.name" />
                </div>
            </BaseCard>
            <BaseCard>
                <div class="space-y-4">
                    <BaseCheckbox label="Perubahan No. HP" />
                    <BaseInput inset type="text" label="No. HP" placeholder="08" required v-model="form.cellphone">
                        <template #append>
                            <p class="mt-2 text-sm text-gray-600">* Harus diisi angka / numerik</p>
                        </template>
                    </BaseInput>
                </div>
            </BaseCard>
            <BaseCard>
                <div class="space-y-4">
                    <BaseCheckbox label="Perubahan / Penambahan Data Bank" />
                    <BaseInput inset type="text" label="No. Rekening" placeholder="350" required
                        v-model="form.bankAccountNumber">
                        <template #append>
                            <p class="mt-2 text-sm text-gray-600">* Harus diisi angka / numerik</p>
                        </template>
                    </BaseInput>
                    <div class="flex flex-col gap-2 md:gap-4 md:items-center md:flex-row">
                        <BaseInput inset type="text" label="Nama Pemilik Rekening" placeholder="AGUNG" class="flex-grow"
                            required v-model="form.bankAccountName" />
                        <BaseCheckbox label="Sama Dengan Nama Distributor" />
                    </div>
                    <BaseInput inset type="text" label="Nama Bank" placeholder="BANK" required
                        v-model="form.bankName" />
                    <BaseInput inset type="text" label="Cabang" placeholder="CABANG" required
                        v-model="form.bankBranchName" />
                </div>
            </BaseCard>
            <BaseCard>
                <div class="space-y-4">
                    <BaseCheckbox label="Perubahan / Penambahan NPWP" />
                    <BaseInput inset type="text" label="KTP" placeholder="KTP" required v-model="form.ktpNumber">
                        <template #append>
                            <p class="mt-2 text-sm text-gray-600">Harus diisi angka / numerik</p>
                        </template>
                    </BaseInput>
                    <BaseInput inset type="text" label="NPWP" placeholder="NPWP" required v-model="form.npwpNumber">
                        <template #append>
                            <p class="mt-2 text-sm text-gray-600">Harus diisi angka / numerik</p>
                        </template>
                    </BaseInput>
                    <BaseInput inset type="text" label="Nama NPWP" placeholder="NAMA" required
                        v-model="form.npwpName" />
                    <BaseInput inset type="text" label="Alamat NPWP" placeholder="ALAMAT" required
                        v-model="form.npwpAddress" />
                    <div class="grid sm:grid-cols-2 gap-4">
                        <BaseInput inset type="text" label="Alamat Lanjutan NPWP" placeholder="ALAMAT" required
                            v-model="form.npwpAddress2" />
                        <BaseInput inset type="text" label="Kota NPWP" placeholder="KOTA" required
                            v-model="form.npwpCity" />
                    </div>
                    <BaseInput label="Status">
                        <div class="flex gap-6">
                            <BaseRadio label="Kawin" required :val="true" v-model="form.maritalStatus" />
                            <BaseRadio label="Belum Kawin" required :val="false" v-model="form.maritalStatus" />
                        </div>
                    </BaseInput>
                    <BaseInput label="Istri / Suami">
                        <div class="flex gap-6">
                            <BaseRadio label="Bekerja" required :val="true" v-model="form.spouseJobStatus" />
                            <BaseRadio label="Tidak Bekerja" required :val="false" v-model="form.spouseJobStatus" />
                        </div>
                    </BaseInput>
                    <BaseInput inset type="text" label="Jumlah Anak + Tanggungan" placeholder="0" required
                        v-model="form.children" />
                </div>
            </BaseCard>
            <div class="flex justify-end gap-2">
                <BaseButton>
                    <Icon icon="heroicons:check-circle-solid" />
                    Simpan
                </BaseButton>
                <BaseButton color="white" type="button" tag="router-link" :to="{ name: 'perubahan-data.index' }">
                    <Icon icon="heroicons:x-mark" />Batal
                </BaseButton>
            </div>
        </form>
    </BaseWrapper>
</template>

<script>
import { mapActions } from 'vuex';
import BaseCheckbox from '../../../../components/base/BaseCheckbox.vue';
import BaseRadio from '../../../../components/base/BaseRadio.vue';
import SearchOfficeInput from '../../../../components/office/search-office-input.vue';
import { requestMixin } from '../../../../mixins/request/request.js';

export default {
    mixins: [requestMixin],
    components: {
        BaseCheckbox,
        BaseRadio,
        SearchOfficeInput
    },
    data() {
        return {
            loadingSubmit: false,
            form: {
                office: {
                    id: null,
                    code: null,
                    tempCode: null,
                    searchCode: null,
                    originalCode: null,
                    name: null,
                },
                cellphone: null,
                bankAccountNumber: null,
                bankAccountName: null,
                bankName: null,
                bankBranchName: null,
                ktpNumber: null,
                npwpNumber: null,
                npwpName: null,
                npwpAddress: null,
                npwpAddress2: null,
                npwpCity: null,
                maritalStatus: true,
                spouseJobStatus: true,
                children: null
            }
        }
    },
    methods: {
        ...mapActions({
            createAlert: 'alert/createAlert'
        }),
        async onSubmit() {
            this.loadingSubmit = true

            const [, err] = await this.request(`/api/v1/office-data-changes`, {
                method: 'post',
                data: {
                    data: {
                        type: 'office-data-changes',
                        attributes: {
                            cellphone: this.form.cellphone,
                            bank_account_number: this.form.bankAccountNumber,
                            bank_account_name: this.form.bankAccountName,
                            bank_name: this.form.bankName,
                            bank_branch_name: this.form.bankBranchName,
                            ktp_number: this.form.ktpNumber,
                            npwp_number: this.form.npwpNumber,
                            npwp_name: this.form.npwpName,
                            npwp_address: this.form.npwpAddress,
                            npwp_address2: this.form.npwpAddress2,
                            npwp_city: this.form.npwpCity,
                            marital_status: this.form.maritalStatus,
                            spouse_job_status: this.form.spouseJobStatus,
                            children: Number(this.form.children)
                        },
                        relationships: {
                            office: {
                                data: {
                                    type: 'offices',
                                    id: this.form.office.id
                                }
                            }
                        }
                    }
                }
            })

            if (err) {
                this.createAlert({
                    type: 'confirm',
                    status: 'error',
                    data: this.getRequestErrorMessage(err),
                    autoClose: false,
                });
            } else {
                this.createAlert({
                    status: 'success',
                    data: 'Perubahan data berhasil disimpan',
                });

                this.$router.push({ name: 'perubahan-data.index' })
            }

            this.loadingSubmit = false
        }
    }
}
</script>